module.exports = __webpack_public_path__ + "assets/img/advantage-item5.7dc8aa32.png";